var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ratesData.length)?_c('div',{staticClass:"header-rates"},_vm._l((_vm.ratesData),function(r){return _c('div',{key:r.label,staticClass:"header-rates__item"},[_c('span',{staticClass:"header-rates__pair"},[_vm._v(_vm._s(r.label))]),_vm._v(" "),_c('span',{staticClass:"header-rates__value",class:{
        'header-rates__value--up': r.flash === 'up',
        'header-rates__value--down': r.flash === 'down'
      }},[_vm._v(_vm._s(r.value))])])}),0):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b24e4f7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/HeaderRates.vue
// module id = null
// module chunks = 